import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Pages/AuthLayout.vue";
import RegistrarPontoFuncionario from "@/pages/Pages/RegistrarPontoFuncionario.vue";
import RegistrarPontoEmpresa from "@/pages/Pages/RegistrarPontoEmpresa.vue";

const Home = () => import("@/pages/Home.vue");

const PesquisarEmpregados = () =>
  import("@/pages/Funcionarios/PesquisarEmpregados.vue");
const CadastrarFuncionariosV2 = () =>
  import("@/pages/Funcionarios/CadastrarFuncionariosV2.vue");
const EditarFuncionariosV2 = () =>
  import("@/pages/Funcionarios/EditarFuncionariosV2.vue");
const HoraLimite = () => import("@/pages/Funcionarios/HoraLimite.vue");
const ConfEscalas = () => import("@/pages/Funcionarios/ConfEscalas.vue");
const PesquisarEscalaDepartamento = () =>
  import("@/pages/Funcionarios/PesquisarEscalaDepartamento.vue");
const CadastrarEscalasDepartamento = () =>
  import("@/pages/Funcionarios/ConfEscalas/CadastrarEscalasDepartamento.vue");
const CadastrarEscalasFuncionario = () =>
  import("@/pages/Funcionarios/ConfEscalas/CadastrarEscalasFuncionario.vue");
const EditarEscalasDepartamento = () =>
  import("@/pages/Funcionarios/ConfEscalas/EditarEscalasDepartamento.vue");
const LancarFolga = () =>
  import("@/pages/Funcionarios/ConfEscalas/LancarFolga.vue");
const EditarFolga = () =>
  import("@/pages/Funcionarios/ConfEscalas/EditarFolga.vue");
const FuncionariosDemitidos = () =>
  import("@/pages/Funcionarios/FuncionariosDemitidos.vue");
const PesquisarFerias = () =>
  import("@/pages/Funcionarios/PesquisarFerias.vue");
const PerfilGerente = () => import("@/pages/Funcionarios/PerfilGerente.vue");
const PermissaoBatida = () =>
  import("@/pages/Funcionarios/PermissaoBatida.vue");
const FichaFuncionarios = () =>
  import("@/pages/Funcionarios/FichaFuncionarios.vue");

const Abonos = () => import("@/pages/Abonos.vue");

const EnviosHolerite = () => import("@/pages/EnviosHolerite.vue");
const EnviosHoleriteIndividual = () =>
  import("@/pages/EnviosHoleriteIndividual.vue");
const ListaHoleriteParaLiberacao = () =>
  import("@/pages/ListaHoleriteParaLiberacao.vue");
const RelatorioDeAssinaturaHolerite = () =>
  import("@/pages/RelatorioDeAssinaturaHolerite.vue");
/////
const ExcluindoDuplicidade = () => import("@/pages/ExcluindoDuplicidade.vue");
/////
const Feriados = () => import("@/pages/Feriados.vue");

const AtestadoTecnico = () => import("@/pages/AtestadoTecnico.vue");

const AnaliticoDePonto = () =>
  import("@/pages/RelatoriosGerenciais/AnaliticoDePonto.vue");
const PainelEscala = () =>
  import("@/pages/RelatoriosGerenciais/PainelEscala.vue");
const RegistroEntradaSaida = () =>
  import("@/pages/RelatoriosGerenciais/RegistroEntradaSaida.vue");
const RelatorioFaltas = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioFaltas.vue");
const RelatorioDeAbsenteismo = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioDeAbsenteismo.vue");
const RelatorioDeAbsenteismo2 = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioDeAbsenteismo2.vue");
const RelatorioDeAdiantamento = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioDeAdiantamento.vue");
const RelatorioDeApuracaoDeFalta = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioDeApuracaoDeFalta.vue");
const RelatorioBeneficios = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioBeneficios.vue");
const RelatorioDeDivergencia = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioDeDivergencia.vue");
const RelatorioDePontoCelular = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioDePontoCelular.vue");
const RelatorioAnaliticoCoordenadas = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioAnaliticoCoordenadas.vue");
const ResumoAnaliticoDePonto = () =>
  import("@/pages/RelatoriosGerenciais/ResumoAnaliticoDePonto.vue");
const RelatorioAniversariantes = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioAniversariantes.vue");
const RelatorioAbonos = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioAbonos.vue");
const RelatorioAssinaturas = () =>
  import("@/pages/RelatoriosGerenciais/RelatorioAssinaturas.vue");
const GraficoJornadaTrabalho = () =>
  import("@/pages/Graficos/JornadaDeTrabalho.vue");
const GraficoResumoAnalitico = () =>
  import("@/pages/Graficos/ResumoAnaliticoDePonto.vue");

// const FecharFolha = () => import("@/pages/FecharFolha/FecharFolha.vue");

const EnviarAssinatura = () =>
  import("@/pages/FecharFolha/EnviarAssinatura.vue");

const VisualizarFolha = () => import("@/pages/FecharFolha/Visualizar.vue");

// const ExportarMasterMaq = () =>
//   import("@/pages/Exportacao/ExportarMasterMaq.vue");

const ConfigurarExportacaoFolha = () =>
  import("@/pages/Exportacao/Configurar.vue");
const ExportacaoAFD = () => import("@/pages/Exportacao/ExportacaoAFD.vue");
const ExportacaoAFDT = () => import("@/pages/Exportacao/ExportacaoAFDT.vue");
const ExportacaoACJEF = () => import("@/pages/Exportacao/ExportacaoACJEF.vue");
const ExportacaoAEJ = () => import("@/pages/Exportacao/ExportacaoAEJ.vue");
const ExportacaoFolha = () => import("@/pages/Exportacao/ExportacaoFolha.vue");

const AfdRelogios = () => import("@/pages/Importacao/AfdRelogios.vue");

const ControlId = () => import("@/pages/Importacao/ControlId.vue");

const sincronizarPontos = () =>
  import("@/pages/Importacao/SincronizarPontos.vue");

const sincronizarUsuarios = () =>
  import("@/pages/Importacao/SincronizarUsuarios.vue");

const sincronizarImagens = () =>
  import("@/pages/Importacao/SincronizarImagens.vue");

const CadastrarControlId = () =>
  import("@/pages/Importacao/CadastrarControlId.vue");

const SolicitacoesDeAbonos = () => import("@/pages/SolicitacoesDeAbonos.vue");

const DadosDaEmpresa = () => import("@/pages/DadosDaEmpresa.vue");
const AtualizarSenha = () => import("@/pages/AtualizarSenha.vue");
const AtualizarSenhaQuiosque = () =>
  import("@/pages/AtualizarSenhaQuiosque.vue");
const AtualizarSenhaUsuario = () =>
  import("@/pages/Usuario/AtualizarSenha.vue");

const PostosDeTrabalho = () => import("@/pages/PostosTrabalho/Index.vue");
const CadEditPostoTrabalho = () =>
  import("@/pages/PostosTrabalho/CadEditPostoTrabalho.vue");

const Login = () => import("@/pages/Pages/Login.vue");
const LoginUsuario = () => import("@/pages/Pages/LoginUsuario.vue");
const PoliticaPrivacidade = () =>
  import("@/pages/Pages/PoliticaPrivacidade.vue");

const ReconhecimentoFacial = () =>
  import("@/pages/Pages/RegistrarPontoFuncionario/ReconhecimentoFacial.vue");
const ReconhecimentoFacialEmpresa = () =>
  import("@/pages/Pages/RegistrarPontoEmpresa/ReconhecimentoFacialEmpresa.vue");

const Usuarios = () => import("@/pages/Usuario/Usuarios.vue");
const Perfis = () => import("@/pages/Usuario/Perfis.vue");

const LogsUsuario = () => import("@/pages/LogsUsuario.vue");

let pagesMenu = {
  path: "/",
  component: DashboardLayout,
  name: "Pages",
  children: [],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        levelAccess: 10,
        public: true,
      },
    },
    {
      path: "/LoginUsuario",
      name: "LoginUsuario",
      component: LoginUsuario,
      meta: {
        levelAccess: 10,
        public: true,
      },
    },
    {
      path: "/politica-privacidade",
      name: "PoliticaPrivacidade",
      component: PoliticaPrivacidade,
      meta: {
        levelAccess: 0,
        public: true,
      },
    },
  ],
};

let registrarPontoFuncionarioPages = {
  path: "/registrarPonto",
  component: RegistrarPontoFuncionario,
  name: "Registrar Ponto",
  children: [
    {
      path: "/",
      name: "Reconhecimento Facial",
      component: ReconhecimentoFacial,
      meta: {
        levelAccess: 10,
      },
    },
  ],
};

let RegistrarPontoEmpresaPages = {
  path: "/registraPonto",
  component: RegistrarPontoEmpresa,
  name: "Registrar Ponto Funcionário",
  children: [
    {
      path: "/",
      name: "Reconhecimento Facial Empresa",
      component: ReconhecimentoFacialEmpresa,
      meta: {
        levelAccess: 7,
      },
    },
  ],
};

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [],
};

let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [],
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [],
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [],
};

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  pagesMenu,
  authPages,
  registrarPontoFuncionarioPages,
  RegistrarPontoEmpresaPages,
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "home",
        name: "Home",
        component: Home,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "pesquisarEmpregados",
        name: "Lista de Funcionários",
        component: PesquisarEmpregados,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "cadastrarFuncionarios/:typeCad",
        name: "Cadastrar Funcionários",
        component: CadastrarFuncionariosV2,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "editarFuncionarios/:id/:typeCad",
        name: "Editar Funcionários",
        component: EditarFuncionariosV2,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "horarioLimite/:id",
        name: "Horário Limite",
        component: HoraLimite,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "confEscalas",
        name: "Configurar Escalas Mensais",
        component: ConfEscalas,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "pesquisarEscalaDepartamento",
        name: "Mod. de Esc. por Dep.",
        component: PesquisarEscalaDepartamento,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "cadastrarEscalaDepartamento",
        name: "Cadastrar Escalas",
        component: CadastrarEscalasDepartamento,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "cadastrarEscalasFuncionario",
        name: "Cadastrar Escalas por Funcionário",
        component: CadastrarEscalasFuncionario,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "editarEscalaDepartamento/:id",
        name: "Cadastrar Escalas",
        component: EditarEscalasDepartamento,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "lancarFolga/:id",
        name: "Lançar Folga",
        component: LancarFolga,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "editarFolga/:id",
        name: "Editar Folga",
        component: EditarFolga,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "funcionariosDemitidos",
        name: "Funcionários Demitidos",
        component: FuncionariosDemitidos,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "pesquisarFerias",
        name: "Lançar Férias/Afastamento",
        component: PesquisarFerias,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "perfilGerente",
        name: "Perfil Gerente",
        component: PerfilGerente,
        meta: {
          levelAccess: 3,
        },
      },
      {
        path: "permissaoBatida",
        name: "Permissão Batida",
        component: PermissaoBatida,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "pesquisarAbonos",
        name: "Abonos",
        component: Abonos,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "enviosHolerite",
        name: "Envios em Lote",
        component: EnviosHolerite,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "enviosHoleriteIndividual",
        name: "Envios por Funcionário",
        component: EnviosHoleriteIndividual,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "listaHoleriteParaLiberacao",
        name: "Lista de Holerites",
        component: ListaHoleriteParaLiberacao,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "relatorioDeAssinaturaHolerite",
        name: "Relatorio de Assinatura de Holerites",
        component: RelatorioDeAssinaturaHolerite,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "excluindoDuplicidade",
        name: "Excluindo Duplicidade",
        component: ExcluindoDuplicidade,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "feriados",
        name: "Cadastrar Feriados",
        component: Feriados,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "relatorioFuncionario",
        name: "Analítico de Ponto",
        component: AnaliticoDePonto,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "painelEscala",
        name: "Painel de Escalas",
        component: PainelEscala,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "entradasSaidas",
        name: "Registro de Entradas/Saídas",
        component: RegistroEntradaSaida,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "relatorioFaltas",
        name: "Relatório de Faltas",
        component: RelatorioFaltas,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "relatorioAbsenteismo",
        name: "Absenteísmo em Horas",
        component: RelatorioDeAbsenteismo,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "relatorioAbsenteismo2",
        name: "Absenteísmo Analítico",
        component: RelatorioDeAbsenteismo2,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "relatorioAdiantamento",
        name: "Relatório de Adiantamento",
        component: RelatorioDeAdiantamento,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "relatorioApuracaoFaltas",
        name: "Relatório de Apuração de Falta",
        component: RelatorioDeApuracaoDeFalta,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "relatorioBeneficios",
        name: "Relatório para Benefícios",
        component: RelatorioBeneficios,
        meta: {
          levelAccess: 5,
        },
      },
      // {
      //   path: "relatorioDivergenciaEscalaModelo",
      //   name: "Relatório de Divergêcia Entre Planejado e Realizado",
      //   component: RelatorioDeDivergencia,
      //   meta: {
      //     levelAccess: 5,
      //   },
      // },
      {
        path: "listagemQrPonto",
        name: "Relatório de Ponto pelo Celular",
        component: RelatorioDePontoCelular,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "listagemCoordenadasGps",
        name: "Relatório Analítico de Coordenadas GPS",
        component: RelatorioAnaliticoCoordenadas,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "relatorioSintetico",
        name: "Relatório Resumo Analítico de Ponto",
        component: ResumoAnaliticoDePonto,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "relatorioAniversariantes",
        name: "Aniversariantes do Mês",
        component: RelatorioAniversariantes,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "relatorioAbonos",
        name: "Relatório de Abonos",
        component: RelatorioAbonos,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "relatorioAssinaturas",
        name: "Relatório de Assinaturas",
        component: RelatorioAssinaturas,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "fichaFuncionarios",
        name: "Ficha de Funcionários",
        component: FichaFuncionarios,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "graficoJornadaTrabalho",
        name: "Jornada de Trabalho",
        component: GraficoJornadaTrabalho,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "graficoResumoAnalitico",
        name: "Resumo Analítico de Ponto",
        component: GraficoResumoAnalitico,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "enviarAssinatura",
        name: "Enviar para Assinatura",
        component: EnviarAssinatura,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "assinatura_ponto",
        name: "Tratamento do Ponto",
        component: VisualizarFolha,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "atestadoTecnico",
        name: "Atestado Técnico",
        component: AtestadoTecnico,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "exportacaoAFD",
        name: "Exportação AFD",
        component: ExportacaoAFD,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "exportacaoAFDT",
        name: "Exportação AFDT",
        component: ExportacaoAFDT,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "exportacaoACJEF",
        name: "Exportação ACJEF",
        component: ExportacaoACJEF,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "exportacaoAEJ",
        name: "Exportação AEJ",
        component: ExportacaoAEJ,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "exportacaoFolha",
        name: "Folha de Pagamento",
        component: ExportacaoFolha,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "configurarRubricaFolha",
        name: "Config Rubricas de Folha",
        component: ConfigurarExportacaoFolha,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "afdRelogios",
        name: "AFD Relógios",
        component: AfdRelogios,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "controlId",
        name: "Conexão com Relógios",
        component: ControlId,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "sincronizarPontos/:id",
        name: "Sincronizar Pontos",
        component: sincronizarPontos,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "sincronizarUsuarios/:id",
        name: "Sincronizar Usuários",
        component: sincronizarUsuarios,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "sincronizarImagens/:id",
        name: "Sincronizar Imagens",
        component: sincronizarImagens,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "cadastrarRelogios",
        name: "Cadastrar Relógios",
        component: CadastrarControlId,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "notificacoesAbonos",
        name: "Notificações de Abonos Solicitados",
        component: SolicitacoesDeAbonos,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "atualizarSenhaQuiosque",
        name: "Atualizar Senha do Quiosque",
        component: AtualizarSenhaQuiosque,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "atualizarSenha",
        name: "Atualizar Senha",
        component: AtualizarSenha,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "AtualizarSenhaUsuario",
        name: "Atualizar Senha",
        component: AtualizarSenhaUsuario,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "atualizarEmpresa",
        name: "Dados da Empresa",
        component: DadosDaEmpresa,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "postosTrabalho",
        name: "Postos de trabalho",
        component: PostosDeTrabalho,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "logsUsuario",
        name: "Logs de Usuário",
        component: LogsUsuario,
        meta: {
          levelAccess: 5,
        },
      },
      {
        path: "cadEditPostoTrabalho/:token/:tipo",
        name: "Postos de trabalho",
        component: CadEditPostoTrabalho,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "usuarios/",
        name: "Usuários",
        component: Usuarios,
        meta: {
          levelAccess: 5,
        },
      },

      {
        path: "usuarios/perfis/",
        name: "Perfis",
        component: Perfis,
        meta: {
          levelAccess: 5,
        },
      },
    ],
  },
];

export default routes;
